import React from 'react';

const LoadingScreen = () => {
  return (
    <div style={styles.container}>
      <div style={styles.spinner}></div>
      <p style={styles.text}>Loading...</p>
    </div>
  );
};

// Inline styles for the loading screen
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Takes up full viewport height
    flexDirection: 'column',
  },
  spinner: {
    border: '4px solid #f3f3f3', /* Light gray */
    borderTop: '4px solid #3498db', /* Blue */
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    animation: 'spin 1s linear infinite',
  },
  text: {
    marginTop: '20px',
    fontSize: '18px',
    color: '#333',
  },
};

// CSS for the spinning animation
const stylesGlobal = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

export default LoadingScreen;
